// extracted by mini-css-extract-plugin
export default {"container":"DataError_container__ShHwv","error":"DataError_error__hsmDd"};